import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import isFunction from 'lodash/isFunction';
import isInteger from 'lodash/isInteger';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';


export default {
	isArray,
	isBoolean,
	isFunction,
	isInteger,
	isNumber,
	isObject,
	isString,
	isUndefined
};
